import type { ThemeProviderProps } from '@mui/material/styles/ThemeProvider';
import _ThemeProvider from '@mui/material/styles/ThemeProvider';
import React from 'react';
import adminTheme from './adminTheme';
const ThemeProvider = function (props: ThemeProviderProps) {
  const theme = props?.theme ?? adminTheme;
  return <_ThemeProvider {...props} theme={theme} />;
};
export default ThemeProvider;